import React from 'react'
import Spinner from '@components/spinner'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

const FormLoader = ({ loading }) => {
  if (!loading) return null

  return (
    <div className='expert-form__loading-overlay'>
      <Spinner center />
    </div>
  )
}

FormLoader.propTypes = {
  loading: PropTypes.bool
}

FormLoader.defaultProps = {
  loading: false
}

export default observer(FormLoader)
